var below = -1; // and this for all values below the base
var base = 0;
var above = 10; // use this for all values above the base
var veryMuch = 1298; // old value to avoid potential z-index issues
// Page Layout
/// ** z-index: -1 */
// const zHidden = below;
/// ** z-index: 0 */
// const zBackground = base;
/// ** z-index: 10 */
// const zContent = above;
/// ** z-index: 20 * */
// const zAction = above + zContent;
/// ** z-index: 30 */
// const zHeader = above + zAction;
/// ** z-index: 1338 */
// const zDrawer = veryMuch + above + zAction; // Drawer
/// ** z-index: 1348 */
// const zAboveDrawer = above + zDrawer; // Flyout
/// ** z-index: 1358 */
// const zImportant = above + zDrawer; // Snackbar, ActionButton, OPN,
var zIndex;
(function (zIndex) {
  /** z-index: -1 */
  zIndex[zIndex["zHidden"] = below] = "zHidden";
  /** z-index: 0 */
  zIndex[zIndex["zBackground"] = base] = "zBackground";
  /** z-index: 10 */
  zIndex[zIndex["zContent"] = above] = "zContent";
  /** z-index: 20 * */
  zIndex[zIndex["zAction"] = above + zIndex.zContent] = "zAction";
  /** z-index: 30 */
  zIndex[zIndex["zHeader"] = above + zIndex.zAction] = "zHeader";
  /** z-index: 1338 */
  zIndex[zIndex["zDrawer"] = veryMuch + above + zIndex.zAction] = "zDrawer";
  /** z-index: 1348 */
  zIndex[zIndex["zAboveDrawer"] = above + zIndex.zDrawer] = "zAboveDrawer";
  /** z-index: 1358 */
  zIndex[zIndex["zImportant"] = above + zIndex.zDrawer] = "zImportant";
})(zIndex || (zIndex = {}));

export { zIndex };
